import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    spacingContainer: { padding: 0 },
    login: { marginBottom: 8 },
    titleLogin: {
      fontFamily: 'Roboto',
      fontSize: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
    },
    subtitleLogin: { marginBottom: 18, fontSize: 14 },
    emailInfo: { fontSize: 11, color: '#727272' },
    orText: { fontSize: 14, marginBottom: 12 },
    optionsGrid: { gap: '8px' },
    validateButtonGrid: { margin: '16px 0px' },
    validateButton: { marginBottom: 16 },
    containerWrapper: {
      maxWidth: 320,
      margin: '0 auto',
      paddingTop: 24,
    },
    pinError: { fontSize: 12 },
    contactAdmin: { padding: 16, maxWidth: 250 },
    muiLink: { textDecoration: 'underline', color: '#0064af' },
    lockIcon: { fontSize: 24 },
    backContainer: { textAlign: 'left', marginTop: 12 },
  });
